import styled from 'styled-components'

export const BaseLayoutStyle = styled.div`
  display: flex;
  flex-flow: column nowrap;
  min-height: 100vh;
  height: 100vh;
`
